import type { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { LoadingSkeleton } from "@kunduz/ui";
import dynamic from "next/dynamic";
import React, { ReactElement } from "react";

/**
 * encapsulate dynamic loading logic to here
 */
export const QuestionSideCtaLoader = (props: Props): ReactElement => {
  const QuestionSideCta = dynamic(
    () => {
      return import("./questionSideCta");
    },
    {
      ssr: false,
      loading: () => (
        <LoadingSkeleton style={{ height: props.isMobile ? 200 : 500 }} />
      ),
    }
  );

  return <QuestionSideCta {...props} />;
};

interface Props {
  isMobile: boolean;
  question?: QuestionIndexing.TrQiQuestion;
  lang: "tr" | "en";
  mode: SideCTAModes;
  translationFile: string;
}

export enum SideCTAModes {
  BLOG = "blog",
  LEARNING = "learning",
  QI = "qi",
  LANDING = "landing",
}

export default QuestionSideCtaLoader;
